<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="businessco_companyname" [ttModel]="edit.businessco_companyname" ttReadonly></tt-input>
        <tt-input ttLabel="accounting_year" [ttModel]="edit.accounting_year" ttReadonly></tt-input>
        <tt-select ttLabel="taxperiod" [(ttModel)]="edit.taxperiod_no" [ttData]="selectListTaxPeriods" ttDataId="taxperiod_no" ttDataName="taxperiod_name"></tt-select>
        <tt-button-save ttText="vatreport_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>
